import React from 'react'
import './Header.css';

const Header = () => {
    return (
        <div className= "header-inscripciones">
            <div className= "titulo-inscripciones">
                <h2>
                    Pago de Inscripciones
                </h2>
            </div>
        </div>      
    );
};

export default Header;